import React from 'react'
import StarsIcon from '../assets/icon/StarsIcon'
import { hexToRGB } from './hexToRGBA'

export interface TaskPriorityOption {
    id: string
    title: string
    color: string
    icon: React.ReactElement
}

export const TASK_PRIORITY_LIST: TaskPriorityOption[] = [
    {
        id: 'urgent',
        title: 'Срочный',
        color: '#E62F2F',
        icon: <StarsIcon color={'#E62F2F'} />,
    },
    {
        id: 'high',
        title: 'Высокий',
        color: '#E78D07',
        icon: <StarsIcon color={'#E78D07'} />,
    },
    {
        id: 'medium',
        title: 'Средний',
        color: '#458CF6',
        icon: <StarsIcon color={'#458CF6'} />,
    },
    {
        id: 'low',
        title: 'Низкий',
        color: '#7E8592',
        icon: <StarsIcon color={'#7E8592'} />,
    },
]

export const getTaskPriority = (priorityId: string | number | null | undefined) => {
    return TASK_PRIORITY_LIST.find((priority) => priority.id === priorityId)
}

export const getTaskPriorityBackground = (priorityId: string | number | null | undefined) => {
    const priority = getTaskPriority(priorityId)
    return priority ? hexToRGB(priority.color, 0.16) : '#F6F5F9'
}
